import {makeStateKey, Injectable, TransferState} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  public constructor(protected cache: TransferState) {

  }

  public getContentsKey(page: string, languageIsoCode: string) {
    return makeStateKey<any[]>("/contents/" + languageIsoCode + "/" + page);
  }

  public getLatest3ArticlesKey() {
    return makeStateKey<any[]>("latest-3-articles");
  }

  public getContentKey(slug: string) {
    return makeStateKey<string>("/content/" + slug);
  }

  public setContents(contents: any[], page, languageIsoCode) {
    this.cache.set(this.getContentsKey(page, languageIsoCode), contents)
  }

  public setLatest3Articles(articles: any[]) {
    this.cache.set(this.getLatest3ArticlesKey(), articles)
  }

  public setContent(slug: string, content: any) {
    this.cache.set(this.getContentKey(slug), content)
  }

  public hasContents(page, languageIsoCode) {
    return this.cache.hasKey(this.getContentsKey(page, languageIsoCode));
  }

  public hasLatest3Articles() {
    return this.cache.hasKey(this.getLatest3ArticlesKey());
  }

  public hasContent(slug: string) {
    return this.cache.hasKey(this.getContentKey(slug));
  }

  public getLatest3Articles(): any[] {
    return this.cache.get(this.getLatest3ArticlesKey(), []);
  }

  public getContents(page, languageIsoCode): any[] {
    return this.cache.get(this.getContentsKey(page, languageIsoCode), []);
  }

  public getContent(slug: string) {
    return this.cache.get(this.getContentKey(slug), null);
  }


}
